/**
 * Loox Cards Carousel → Figma/Judge shell:
 * - Top square arrows scroll the track (and click Loox nav if found)
 * - Hide Loox circular side arrow
 * - Normalize card layout: image → stars → body → name + Verified Buyer
 * - Full review text (no clamp); cards hug content height
 */
(function () {
  var MARK = 'data-apps-figma-loox';
  var VERIFIED_CLASS = 'apps-figma-loox-verified-label';
  var CARD_CLASS = 'apps-figma-loox-card';
  var STEP = 256; /* 246 + 10 */

  function cssHref() {
    return window.__APPS_FIGMA_LOOX_CSS__ ? String(window.__APPS_FIGMA_LOOX_CSS__) : '';
  }

  function injectLink(root) {
    if (!root || root.querySelector('link[' + MARK + ']')) return;
    var href = cssHref();
    if (!href) return;
    var link = document.createElement('link');
    link.setAttribute(MARK, '1');
    link.rel = 'stylesheet';
    link.href = href;
    (root.head || root).appendChild ? (root.head || root).appendChild(link) : root.appendChild(link);
  }

  function shells() {
    return document.querySelectorAll('.apps-figma-reviews-shell');
  }

  function walkDeep(root, visit) {
    if (!root) return;
    visit(root);
    var nodes = root.querySelectorAll ? root.querySelectorAll('*') : [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      visit(el);
      if (el.shadowRoot) walkDeep(el.shadowRoot, visit);
    }
  }

  function findLooxRoot(shell) {
    if (!shell) return null;
    return (
      shell.querySelector('#LOOX-V2_CAROUSEL-card') ||
      shell.querySelector('.loox-v2-carousel-container[data-slide-type="card"]') ||
      shell.querySelector('[id*="LOOX-V2_CAROUSEL"]') ||
      shell.querySelector('#loox-default-carousel') ||
      shell.querySelector('.loox-v2-carousel-container') ||
      shell.querySelector('.apps-figma-reviews-shell__slot')
    );
  }

  function isCircularNav(el) {
    if (!el || el.closest('.apps-figma-reviews-shell__header')) return false;
    var tag = (el.tagName || '').toLowerCase();
    if (tag !== 'button' && el.getAttribute('role') !== 'button' && tag !== 'a') return false;
    var r = el.getBoundingClientRect();
    if (r.width < 28 || r.width > 64 || Math.abs(r.width - r.height) > 8) return false;
    var cs = window.getComputedStyle(el);
    var br = cs.borderRadius || '';
    if (br.indexOf('50%') !== -1 || br.indexOf('999') !== -1 || parseFloat(br) >= r.width / 2 - 2) {
      return true;
    }
    return false;
  }

  function looksLikeNav(el, dir) {
    if (!el || el.closest('.apps-figma-reviews-shell__header')) return false;
    var label = (
      (el.getAttribute('aria-label') || '') +
      ' ' +
      (el.getAttribute('title') || '') +
      ' ' +
      (el.className || '')
    ).toLowerCase();
    if (dir === 'prev') {
      return /prev|previous|left|back|geri/.test(label);
    }
    return /next|right|ileri|forward/.test(label);
  }

  function findNavButtons(shell) {
    var found = { prev: null, next: null, circular: [] };
    var scope = shell.querySelector('.apps-figma-reviews-shell__slot') || shell;
    walkDeep(scope, function (el) {
      if (!el || el.nodeType !== 1) return;
      if (isCircularNav(el)) {
        found.circular.push(el);
        el.setAttribute(MARK + '-native-arrow', '1');
      }
      if (!found.prev && looksLikeNav(el, 'prev')) found.prev = el;
      if (!found.next && looksLikeNav(el, 'next')) found.next = el;
    });
    if (!found.next && found.circular.length) {
      found.next = found.circular[found.circular.length - 1];
    }
    return found;
  }

  function findScrollTrack(shell) {
    var loox = findLooxRoot(shell);
    if (!loox) return null;

    var best = null;
    var bestScore = 0;

    walkDeep(loox, function (el) {
      if (!el || el.nodeType !== 1 || !el.getBoundingClientRect) return;
      if (el.closest && el.closest('.apps-figma-reviews-shell__header')) return;
      var cs = window.getComputedStyle(el);
      var ox = cs.overflowX;
      var display = cs.display;
      var scrollable =
        (ox === 'auto' || ox === 'scroll' || ox === 'overlay') && el.scrollWidth > el.clientWidth + 8;
      var flexRow =
        (display === 'flex' || display === 'inline-flex') &&
        (cs.flexDirection === 'row' || cs.flexDirection === 'row-reverse') &&
        el.scrollWidth > el.clientWidth + 8;

      if (scrollable || flexRow) {
        var score = el.scrollWidth - el.clientWidth;
        if (score > bestScore) {
          bestScore = score;
          best = el;
        }
      }
    });

    if (best) return best;

    /* Fallback: widest child row inside loox */
    var candidates = loox.querySelectorAll('div, ul, section');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.scrollWidth > el.clientWidth + 40) return el;
    }
    return loox;
  }

  function getStep(track) {
    if (!track) return STEP;
    var card =
      track.querySelector('.' + CARD_CLASS) ||
      track.querySelector('[class*="card"]') ||
      track.querySelector('[class*="slide"]') ||
      track.querySelector('li');
    if (card) {
      var w = card.getBoundingClientRect().width;
      if (w > 100) return Math.round(w + 10);
    }
    return STEP;
  }

  function scrollTrack(shell, dir) {
    var track = findScrollTrack(shell);
    if (!track) return false;
    var delta = getStep(track) * (dir === 'prev' ? -1 : 1);
    try {
      if (typeof track.scrollBy === 'function') {
        track.scrollBy({ left: delta, behavior: 'smooth' });
      } else {
        track.scrollLeft += delta;
      }
      return true;
    } catch (e) {
      track.scrollLeft += delta;
      return true;
    }
  }

  function pickNavBtn(nav, dir) {
    if (dir === 'prev') {
      return nav.prev || (nav.circular.length > 1 ? nav.circular[0] : null);
    }
    return nav.next || nav.circular[nav.circular.length - 1] || null;
  }

  function clickNative(shell, dir) {
    var nav = findNavButtons(shell);
    var btn = pickNavBtn(nav, dir);
    if (!btn) return false;
    try {
      btn.style.setProperty('pointer-events', 'auto', 'important');
      btn.style.setProperty('opacity', '0', 'important');
      btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      btn.click();
      return true;
    } catch (e) {
      return false;
    }
  }

  function trySwiper(shell, dir) {
    var loox = findLooxRoot(shell);
    if (!loox) return false;
    var hit = null;
    walkDeep(loox, function (node) {
      if (hit || !node) return;
      if (node.swiper && typeof node.swiper.slideNext === 'function') hit = node.swiper;
    });
    if (!hit) return false;
    try {
      if (dir === 'prev') hit.slidePrev();
      else hit.slideNext();
      return true;
    } catch (e) {
      return false;
    }
  }

  function wireArrows(shell) {
    var prev = shell.querySelector('.apps-figma-reviews-shell__arrow--prev');
    var next = shell.querySelector('.apps-figma-reviews-shell__arrow--next');
    if (!prev || !next) return;

    function go(dir) {
      trySwiper(shell, dir);
      clickNative(shell, dir);
      scrollTrack(shell, dir);
    }

    if (prev.getAttribute(MARK + '-wired') !== '1') {
      prev.setAttribute(MARK + '-wired', '1');
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        go('prev');
      });
    }
    if (next.getAttribute(MARK + '-wired') !== '1') {
      next.setAttribute(MARK + '-wired', '1');
      next.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        go('next');
      });
    }

    /* Mark native circular arrows for CSS hide */
    findNavButtons(shell);
  }

  function expandText(el) {
    if (!el) return;
    el.style.setProperty('-webkit-line-clamp', 'unset', 'important');
    el.style.setProperty('line-clamp', 'unset', 'important');
    el.style.setProperty('max-height', 'none', 'important');
    el.style.setProperty('height', 'auto', 'important');
    el.style.setProperty('overflow', 'visible', 'important');
    el.style.setProperty('text-overflow', 'clip', 'important');
    el.style.setProperty('white-space', 'normal', 'important');
    var full =
      el.getAttribute('title') ||
      el.getAttribute('data-full-text') ||
      el.getAttribute('aria-label') ||
      '';
    var t = (el.textContent || '').trim();
    if (
      full &&
      full.length > t.length + 2 &&
      (t.slice(-1) === '…' || t.slice(-3) === '...' || /\.\.\.$/.test(t))
    ) {
      el.textContent = full;
    }
  }

  function normalizeCards(shell) {
    var loox = findLooxRoot(shell);
    if (!loox) return;

    var cards = [];
    walkDeep(loox, function (el) {
      if (!el || el.nodeType !== 1) return;
      if (el.classList && el.classList.contains(CARD_CLASS)) {
        cards.push(el);
        return;
      }
      /* Heuristic: element with an image + some text, ~card sized */
      if (el.querySelector && el.querySelector('img') && (el.textContent || '').length > 20) {
        var r = el.getBoundingClientRect();
        if (r.width >= 160 && r.width <= 360 && r.height >= 180) {
          var parentCard = el.parentElement && el.parentElement.closest && el.parentElement.closest('.' + CARD_CLASS);
          if (!parentCard && !el.closest('.' + CARD_CLASS)) {
            /* Prefer deepest such nodes — mark leaf-ish cards */
            var hasNestedImgCard = false;
            var kids = el.children || [];
            for (var i = 0; i < kids.length; i++) {
              if (kids[i].querySelector && kids[i].querySelector('img') && (kids[i].textContent || '').length > 20) {
                hasNestedImgCard = true;
                break;
              }
            }
            if (!hasNestedImgCard) cards.push(el);
          }
        }
      }
    });

    /* Deduplicate nested */
    cards = cards.filter(function (c, idx, arr) {
      for (var i = 0; i < arr.length; i++) {
        if (i !== idx && c !== arr[i] && c.contains(arr[i])) return false;
      }
      return true;
    });

    cards.forEach(function (card) {
      card.classList.add(CARD_CLASS);
      card.setAttribute(MARK + '-card', '1');

      var imgs = card.querySelectorAll('img, video');
      if (imgs[0]) imgs[0].classList.add('apps-figma-loox-card__media');

      /* Stars container: node that mostly contains star svgs / ★ */
      var starHost = null;
      card.querySelectorAll('div, span, p').forEach(function (n) {
        if (starHost) return;
        var svgs = n.querySelectorAll('svg');
        var text = (n.textContent || '').replace(/\s/g, '');
        if (svgs.length >= 3 || /★★★★★|★★★★☆/.test(text) || (n.className + '').toLowerCase().indexOf('star') !== -1) {
          starHost = n;
        }
      });
      if (starHost) {
        starHost.classList.add('apps-figma-loox-card__stars');
        /* Climb one if badge wrapper */
        var p = starHost.parentElement;
        if (p && p !== card && p.querySelectorAll('svg').length >= 3 && p.children.length <= 3) {
          p.classList.add('apps-figma-loox-card__stars');
          starHost = p;
        }
      }

      var nameEl =
        card.querySelector('[class*="name"]') ||
        card.querySelector('[class*="author"]') ||
        card.querySelector('[class*="reviewer"]');
      if (nameEl) {
        nameEl.classList.add('apps-figma-loox-card__name');
        var footer = nameEl.closest('div') || nameEl.parentElement;
        if (footer && footer !== card) footer.classList.add('apps-figma-loox-card__footer');
        else nameEl.classList.add('apps-figma-loox-card__footer');
      }

      card.querySelectorAll('p, [class*="text"], [class*="body"], [class*="content"]').forEach(function (n) {
        if (n.classList.contains('apps-figma-loox-card__name')) return;
        if (n.classList.contains('apps-figma-loox-card__stars')) return;
        if ((n.textContent || '').trim().length < 8) return;
        n.classList.add('apps-figma-loox-card__body');
        expandText(n);
      });

      /* Verified Buyer */
      if (nameEl && !card.querySelector('.' + VERIFIED_CLASS)) {
        var host = nameEl.parentElement || nameEl;
        if (!/verified/i.test(host.textContent || '')) {
          var span = document.createElement('span');
          span.className = VERIFIED_CLASS;
          span.textContent = 'Verified Buyer';
          host.appendChild(span);
        }
      }

      expandText(card);
      card.querySelectorAll('.apps-figma-loox-card__body, p').forEach(expandText);
    });
  }

  function splitTitle(el) {
    if (!el || el.querySelector('br.apps-figma-judge-title-break')) return;
    var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
    var m = t.match(/^(.*?customers)\s+(worldwide.*)$/i);
    if (!m) return;
    el.innerHTML = m[1].trim() + ' <br class="apps-figma-judge-title-break">' + m[2].trim();
  }

  function makeTrackScrollable(shell) {
    var track = findScrollTrack(shell);
    if (!track) return;
    track.classList.add('apps-figma-loox-track');
    track.style.setProperty('overflow-x', 'auto', 'important');
    track.style.setProperty('overflow-y', 'visible', 'important');
    track.style.setProperty('scroll-behavior', 'smooth', 'important');
    track.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
    track.style.setProperty('scrollbar-width', 'none', 'important');
  }

  function enhance() {
    shells().forEach(function (shell) {
      /* Skip pure Judge shells */
      if (shell.querySelector('.jdgm-cards-carousel') && !shell.querySelector('[class*="loox"], #loox-default-carousel, #LOOX-V2_CAROUSEL-card')) {
        return;
      }
      injectLink(document.head);
      injectLink(shell);
      walkDeep(shell, function (el) {
        if (el && el.shadowRoot) injectLink(el.shadowRoot);
      });
      splitTitle(shell.querySelector('.apps-figma-reviews-shell__title'));
      normalizeCards(shell);
      makeTrackScrollable(shell);
      wireArrows(shell);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }
  document.addEventListener('shopify:section:load', enhance);
  setTimeout(enhance, 600);
  setTimeout(enhance, 1500);
  setTimeout(enhance, 3000);
  setTimeout(enhance, 6000);

  var scheduled = false;
  var obs = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      enhance();
    });
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
